export default __webpack_public_path__ + "static/media/bundle-coach-aok-northwest@1x.e538a946.webp";